import { createBrowserRouter } from 'react-router-dom';

import { AdminLayout } from './AdminLayout';
import { RequireAuth } from '../../features/auth/components/RequireAuth';
import LoginPage from '../../features/auth/pages/LoginPage';
import DashboardPage from '../../features/dashboard/pages/DashboardPage';
import ConsultationsPage from '../../features/consultations/pages/ConsultationsPage';
import ContractsPage from '../../features/contracts/pages/ContractsPage';
import WorkSprintsPage from '../../features/work-sprints/pages/WorkSprintsPage';
import ActionItemsPage from '../../features/action-items/pages/ActionItemsPage';

export const adminRouter = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <AdminLayout />,
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          {
            path: 'consultations',
            element: <ConsultationsPage />,
          },
          {
            path: 'contracts',
            element: <ContractsPage />,
          },
          {
            path: 'work-sprints',
            element: <WorkSprintsPage />,
          },
          {
            path: 'action-items',
            element: <ActionItemsPage />,
          },
        ],
      },
    ],
  },
]);
